import React, { useContext, useEffect, useState } from "react";
import KnowledgeTest from "./KnowledgeTest";
import { UserContext } from "../../UserContext";
import { Modal, Card, Button } from "antd";
import './Course.css';
import { useLocation, useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
const AllCourses = () => {

	const navigate = useNavigate();
    const [courses, setCourses] = useState({});
    const { studentapiuri , token } = useContext(UserContext);
	const [moduleVisible,setModuleVisible] = useState(false);
	const {courseId} = useLocation();

    const fetchAllCourses = async () =>{
        const response = await fetch(`${studentapiuri}/stud/allcourses`, {
					method: "GET",
					headers: {
						"Content-Type": "application/json",
						Authorization: "BEARER " + token
					},
				});
        const data = await response.json();
        setCourses(data?.data);
    }


    useEffect(()=>{
        fetchAllCourses();
    },[]);

    const RegisterCourse = async (courseId) => {
			console.log({ courseId: courseId });
			const response = await fetch(`${studentapiuri}/stud/registercourse`, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: "BEARER " + token,
				},
				body: JSON.stringify({ courseId: courseId }),
			});
			if (!response.ok) {
				console.log(`HTTP error! Status: ${response.status}`);
			}
			const data = await response.json();
		};

	const GotoCourse = async (courseId) => {
		if (!courses[courseId].ktDone) {
			setModuleVisible(true);
		} else navigate(`/student/courses/${courseId}/module/1/submodule/1`);
	};

	const handleKnowledgeTest = async (courseId) => {
		const response = await fetch(`${studentapiuri}/stud/getkt/${courseId}`, {
			method: "GET",
			headers: {
				Authorization: "BEARER " + token,
			},
		});
		console.log(response);
		const data = await response.json();
		console.log(data);
		navigate(`/student/knowledgetest/${courseId}`, { state: data.data.kt });
	};


	return (
		<>
		<div className="student-course-list">
		{courses && Object.keys(courses).map((course,i)=>{
			return (
				<Card
					key={i}
					title={courses[course].data.courseOn}
					className="student-courses">
					<Link to={`/student/courses/outline/${course}`}>
						<div className="course-target">
							<span>Target: </span>
							{courses[course].data.target}
						</div>
						<div className="course-duration">
							<span>Duration: </span>
							{courses[course].data.duration}
						</div>
					</Link>
					<div className="register-button">
						{courses[course].isRegistered === true ? (
							<Button onClick={async () => await GotoCourse(course)}>
								Go to Course
							</Button>
						) : (
							<Button onClick={async () => await RegisterCourse(course)}>
								Register
							</Button>
						)}
					</div>
					<Modal
						open={moduleVisible}
						okText="Yes"
						footer=""
						onCancel={() => setModuleVisible(false)}
						onOk={async () => await handleKnowledgeTest(course)}
						cancelText="No">
						<p>Click Yes to proceed for Knowledge Test</p>
					</Modal>
				</Card>
			);
		})
		}
		</div>
		</>
	);
};

export default AllCourses;
